import { KeyboardEvent } from 'react';

export const handleLinkKeyDown = (event: KeyboardEvent<HTMLElement>) => {
	if (event.key !== 'Enter') return;
	event.preventDefault();
	event.currentTarget.click();
};

export const handleButtonKeyDown = (event: KeyboardEvent<HTMLElement>) => {
	if (event.key !== 'Enter' && event.key !== ' ') return;
	event.preventDefault();
	event.currentTarget.click();
};
